import { render, staticRenderFns } from "./rgtphxSet.vue?vue&type=template&id=4303af18&scoped=true&"
import script from "./rgtphxSet.vue?vue&type=script&lang=js&"
export * from "./rgtphxSet.vue?vue&type=script&lang=js&"
import style0 from "./rgtphxSet.vue?vue&type=style&index=0&id=4303af18&prod&lang=scss&scoped=true&"
import style1 from "./rgtphxSet.vue?vue&type=style&index=1&id=4303af18&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4303af18",
  null
  
)

export default component.exports